module.exports = __webpack_public_path__ + "img/xqtl.f6fc8654.png";